import React, { useState } from "react";
import { Spinner, TextField, Text } from "@shopify/polaris";
import { cross } from "../../../assets";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { RequestAccess } from "../../dev_services/developer/api";
import { Modal } from "@mui/material";
import ErrorDialog from "../error_dialog/error_dialog";

const SubmitPermissionDialog: React.FC<SubmitAppDialogProps> = ({
  open,
  onClose,
  moduleName,
  moduleId,
  permissionID,
}) => {
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");
  const [errorReason, setErrorReason] = useState(false);
  const [errorSubmitApps, setErrorApp] = useState("");
  const { appID } = useParams();

  const handleRequestAccess = async () => {
    try {
      setLoading(true);

      await RequestAccess(
        { module_id: moduleId, permission_ids: permissionID, reason },
        appID
      );
      toast.success("API request sent Sucessfully");
      setTimeout(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }, 1000);
    } catch (error) {
      toast.error("Error requesting access");
    } finally {
      setLoading(false);
    }
  };
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Function to handle closing the error dialog
  const handleCloseErrorDialog = () => {
    setErrorDialogOpen(false);
  };

  // Function to handle an error
  const handleShowError = (message: string) => {
    setErrorMessage(message); // Set the error message
    setErrorDialogOpen(true); // Open the error dialog
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <div
          style={{
            width: "auto",
            height: "370px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "20px",
            outline: "none",
            borderRadius: "10px",
          }}
        >
          <div
            style={{ position: "absolute", top: 0, right: 0, padding: "5px" }}
          >
            <img
              style={{ width: "40px", cursor: "pointer" }}
              src={cross}
              alt="Close Icon"
              onClick={onClose}
            />
          </div>
          <div style={{ width: "auto", padding: "20px" }}>
            <div style={{ marginBottom: "10px" }}>
              <Text variant="headingLg" as="h5">
                {moduleName}
              </Text>{" "}
              {/* {description} */}
            </div>
            <div>
              <label style={{ fontFamily: "sfproregular" ,fontSize:"14px"}}>
                Users will be notified of this additional scope when they install your app. Unnecessary access scope use could result in fewer installs.
              </label>
            <div style={{paddingTop:"20px"}}>
            <label style={{ fontFamily: "sfproregular" ,fontSize:"14px" }}>
                Describe your app and how it helps users.
              </label>
            </div>

              <div style={{ paddingTop: "10px" }}>
                <TextField
                  label=""
                  autoComplete=""
                  placeholder="Please Enter reason for the api you are requesting..."
                  multiline={3}
                  value={reason}
                  onChange={(newValue) => {
                    // Clear the error flag when user starts typing in the reason field
                    setErrorReason(false);
                    setReason(newValue);
                  }}
                  maxLength={250}
                  showCharacterCount
                  error={errorReason} // Set the error state of the TextField
                />
              </div>
            </div>

            {errorReason && (
              <span style={{ color: "red" }}>Reason cannot be empty</span>
            )}
          </div>
          <div style={{ textAlign: "center" }}>
            {loading ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Spinner size="small" />
              </div>
            ) : (
              <button className="button" onClick={handleRequestAccess}>
                <Text variant="bodyMd" as="p">
                  Submit Request
                </Text>
              </button>
            )}
          </div>
        </div>
      </Modal>
      <div>
        <ErrorDialog
          open={errorDialogOpen}
          onClose={handleCloseErrorDialog}
          errorMessage={errorSubmitApps}
        />
      </div>
    </>
  );
};

// Define PropTypes for the component
interface SubmitAppDialogProps {
  open: boolean;
  onClose: () => void;
  permissionID: string[];
  moduleName: string;
  moduleId:string;
  description: any;
}

export default SubmitPermissionDialog;
